import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm, Form } from 'redux-form';
import TextField from '../common/TextField';
import FileField from '../common/FileField';

const required = (value) => (value && value !== '' ? undefined : 'Required');

function NotificationForm(props) {
  const { handleSubmit, pristine, submitting, closeDialog } = props;

  // Get Initial Data

  return (
    <Form onSubmit={handleSubmit} className="customForm addMembership coupons">
      <div>
        <Field
          name="title"
          component={TextField}
          label="Notification Title"
          placeholder="Enter Notification Title"
          validate={required}
        />
      </div>
      <div>
        <Field
          name="body"
          component={TextField}
          label="Notification Body"
          placeholder="Enter Notification Body"
          validate={required}
        />
      </div>
      <div>
        <Field
          name="notificationImage"
          label="Select Notification Image(Optional)"
          placeholder="Select Notification Image(Optional)"
          component={FileField}
          validate={undefined}
        />
      </div>

      <div className="text-right">
        <button type="button" onClick={closeDialog} className="submit-button cancel-button">
          Cancel
        </button>
        <button type="submit" className="submit-button" disabled={pristine || submitting}>
          Send
        </button>
      </div>
    </Form>
  );
}

NotificationForm.propTypes = {
  closeDialog: PropTypes.func,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};

NotificationForm.defaultProps = {
  closeDialog: undefined,
  handleSubmit: undefined,
  pristine: undefined,
  submitting: undefined,
};

export default reduxForm({
  form: 'addMembership',
})(NotificationForm);
